Promise.all([import('scripts/marmalade/classes/page-filters')]).then(_ref => {
  let [modulePageFilters] = _ref;
  // Define the components
  const PageFiltersController = modulePageFilters.default;

  // Find the page
  const page = document.querySelector('.js-blog-holder');
  // Find the search list
  const list = page.querySelector('.js-blog-holder__list');
  // Find the search form
  const form = page.querySelector('.js-blog-holder__form');
  // Find the search results
  const results = page.querySelector('.js-blog-holder__results');

  // The pagination selector
  const LOAD_MORE_SELECTOR = '.js-blog-holder__load-more';
  // The pagination parameter
  const LOAD_MORE_PARAMETER = 'page';

  // Create a new FilterController
  const PageFilters = new PageFiltersController(form);

  // A var to determine if the page is loading more or replacing the results
  let LOADING_MORE = false;
  // The load more button
  let loadmore = page.querySelector(LOAD_MORE_SELECTOR);

  /* ----------------------------------
  Functions
  ---------------------------------- */

  const addNewInputs = () => {
    // Find the load more button
    loadmore = page.querySelector(LOAD_MORE_SELECTOR);

    // If there is no limit, return
    if (!loadmore) return;

    // When the load more button is clicked
    loadmore.addEventListener('click', e => {
      // Prevent the default action
      e.preventDefault();
      if (e.target.tagName === 'BUTTON') {
        // Set loading more to true
        LOADING_MORE = true;
        // Set the page number
        PageFilters.set(LOAD_MORE_PARAMETER, parseInt(e.target.value) + 1);
        // Submit the filters
        PageFilters.submit();
      }
    });
  };

  /* ----------------------------------
  Document setup
  ---------------------------------- */

  // When the form is submitted
  PageFilters.on('submit', () => {
    // Add a spinner class to the list
    list.classList.add('spinner');
    if (!LOADING_MORE) {
      // Add a loading class to the results if we're not loading more
      list.classList.add('loading');
      // Smooth scroll the page to the top of the results
      window.ScrollController.scrollTo(window.getOffsetY(results) - 200, 500);
    }
  });

  // When the filter is applied and loads successfully
  PageFilters.on('success', response => {
    // Remove the button
    if (loadmore) loadmore.remove();
    // If we're not loading more clear the results
    if (!LOADING_MORE) results.innerHTML = '';
    // Append the results to the list
    results.innerHTML += response;
    // Set the loading more var to false
    LOADING_MORE = false;
  });

  // PageFilters.on('pageChanged', () => {
  //   window.ScrollController.scrollTo(window.getOffsetY(results) - 200, 500);
  // });

  // When the filter is applied but there is an error
  PageFilters.on('error', response => {
    // Tell the user there was an error
    console.warn('There was an error loading the results. Error code:', response);
    results.innerHTML = `<p class="text-center">There was an error loading the results.</p>`;
  });

  // When the page filters have completed
  PageFilters.on('complete', () => {
    // Remove the page parameter from the filter
    PageFilters.remove(LOAD_MORE_PARAMETER);

    // Remove all the loading classes
    list.classList.remove('loading', 'spinner');

    // Add the new inputs
    addNewInputs();
  });
  addNewInputs();
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});